var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnRightDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 32,
    viewBox: "0 0 15 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 31.6667L15 23.2815L15 8.38532V8.2016e-05L3.75851 11.176L4.70077 13.3113L7.54105 15.8334L4.70077 18.3555L3.7585 20.4908L15 31.6667Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9071 15.8333L2.95353 13.1923L-5.24521e-05 15.8333L2.95353 18.4744L5.9071 15.8333Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRightDecor);
export default __webpack_public_path__ + "static/media/btn-right-decor.fda642809d34af62b91f3c7c7b3a3e7c.svg";
export { ForwardRef as ReactComponent };